/* Pearl & Vane product page v3 — gallery, variants, add to bag (cart drawer), sticky bar, zoom, delivery line. */
(function () {
  function money(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function addBiz(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()), c = 0; while (c < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; } return x; }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }

  function init(root) {
    if (root.dataset.pvxReady) return; root.dataset.pvxReady = '1';
    var data = JSON.parse(root.querySelector('[data-pvx-json]').textContent);
    var form = root.querySelector('[data-pvx-form]');
    var idInput = root.querySelector('[data-pvx-id]');
    var atc = root.querySelector('[data-pvx-atc]');
    var atcLabel = root.querySelector('[data-pvx-atc-label]');
    var err = root.querySelector('[data-pvx-error]');
    var prices = root.querySelectorAll('[data-pvx-price]');
    var track = root.querySelector('[data-pvx-track]');
    var bar = root.querySelector('[data-pvx-bar]');
    var barBtn = root.querySelector('[data-pvx-bar-btn]');

    /* delivery line */
    var eta = root.querySelector('[data-pvx-eta]');
    if (eta) { var now = new Date(); eta.querySelector('[data-pvx-eta-range]').textContent = fmt(addBiz(now, +eta.dataset.min || 6)) + ' – ' + fmt(addBiz(now, +eta.dataset.max || 14)); }

    /* gallery counter + dots (mobile swipe) */
    var count = root.querySelector('[data-pvx-count]');
    var dots = root.querySelectorAll('.pvx__dots span');
    function onScroll() {
      var w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w);
      if (count) count.textContent = i + 1;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });

    /* zoom */
    var lb = root.querySelector('[data-pvx-lightbox]'), lbImg = root.querySelector('[data-pvx-zoom-img]');
    root.querySelectorAll('[data-pvx-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = b.querySelector('img'); lbImg.src = b.dataset.pvxZoom; lbImg.alt = img ? img.alt : '';
        lb.hidden = false; document.documentElement.classList.add('pvx-noscroll'); lb.querySelector('[data-pvx-close]').focus();
      });
    });
    function closeLb() { lb.hidden = true; document.documentElement.classList.remove('pvx-noscroll'); }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-pvx-close') || e.target.closest('.pvx-zoom__frame')) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });

    /* variants */
    var opts = root.querySelectorAll('[data-pvx-opt]');
    function selected() { return Array.prototype.map.call(opts, function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
    function setState(v) {
      var ok = v && v.available;
      atc.disabled = !ok; if (barBtn) barBtn.disabled = !ok;
      atcLabel.textContent = !v ? 'Unavailable' : (ok ? 'Add to bag' : 'Sold out');
      if (barBtn) barBtn.textContent = atcLabel.textContent;
    }
    function onChange() {
      var sel = selected();
      opts.forEach(function (f, i) { var s = f.querySelector('[data-pvx-optval]'); if (s) s.textContent = sel[i]; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      setState(v);
      if (!v) return;
      idInput.value = v.id;
      prices.forEach(function (p) { p.textContent = money(v.price); }); root.querySelectorAll('[data-pvx-cmp]').forEach(function (c) { var on = v.compare_at_price && v.compare_at_price > v.price; c.hidden = !on; c.textContent = on ? money(v.compare_at_price) : ''; }); root.querySelectorAll('[data-pvx-sale]').forEach(function (s) { var on = v.compare_at_price && v.compare_at_price > v.price; s.hidden = !on || Date.now() > 1793505540000; });
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      if (v.featured_media && track) {
        var li = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (li && li !== track.firstElementChild) { track.insertBefore(li, track.firstElementChild); }
        track.scrollTo({ left: 0, behavior: 'smooth' }); onScroll();
      }
    }
    opts.forEach(function (f) { f.addEventListener('change', onChange); });

    /* add to bag via Dawn's cart drawer */
    function add(e) {
      if (e) e.preventDefault();
      if (atc.disabled) return;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: +idInput.value, quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true'); err.hidden = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { err.textContent = res.description || res.message || 'Could not add to bag.'; err.hidden = false; return; }
        if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      }).catch(function () { err.textContent = 'Could not add to bag. Please try again.'; err.hidden = false; })
        .finally(function () { atc.classList.remove('is-loading'); atc.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', add);
    if (barBtn) barBtn.addEventListener('click', function () { add(); });

    /* mobile sticky bar: show once the main button scrolls out of view */
    if (bar && 'IntersectionObserver' in window) {
      document.body.appendChild(bar);
      var io = new IntersectionObserver(function (en) {
        var e = en[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); barBtn.tabIndex = show ? 0 : -1;
      });
      io.observe(atc);
    }
  }
  function boot() { document.querySelectorAll('.pvx[data-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* "You may also like": never repeat the current product or anything in "Pairs well with"; max 4; hide if < 2. */
(function () {
  function handleOf(a) { try { var m = new URL(a.href, location.origin).pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; } }
  function run(rec) {
    var cfgEl = document.querySelector('[data-pv-pairs]'); if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var ex = {}; ex[cfg.current] = 1; (cfg.pairs || []).forEach(function (h) { if (h) ex[h] = 1; });
    var items = rec.querySelectorAll('.grid__item, li'); if (!items.length) return;
    var kept = 0, seen = {};
    Array.prototype.forEach.call(rec.querySelectorAll('ul > li, .grid > .grid__item'), function (li) {
      var a = li.querySelector('a[href*="/products/"]'); var h = a && handleOf(a);
      if (!h || ex[h] || seen[h] || kept >= 4) { li.remove(); return; }
      seen[h] = 1; kept++;
    });
    var sec = rec.closest('.shopify-section') || rec;
    if (kept < 2) { sec.style.display = 'none'; rec.classList.add('pv-hide'); } else { sec.style.display = ''; }
    rec.dataset.pvFiltered = kept;
  }
  function boot() {
    document.querySelectorAll('product-recommendations').forEach(function (rec) {
      var mo = new MutationObserver(function () { if (rec.querySelector('a[href*="/products/"]') && !rec.dataset.pvBusy) { rec.dataset.pvBusy = '1'; run(rec); delete rec.dataset.pvBusy; } });
      mo.observe(rec, { childList: true, subtree: true });
      if (rec.querySelector('a[href*="/products/"]')) run(rec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* October Sale tag fallback expiry (Oct 31 2026 23:59 ET) */
(function(){function h(){if(Date.now()>1793505540000)document.querySelectorAll('[data-pvx-sale],.pv-sale-badge').forEach(function(e){e.hidden=true;e.style.setProperty('display','none','important');});}if(document.readyState!=='loading')h();else document.addEventListener('DOMContentLoaded',h);})();
